import { CampoSpecificoConservazioneDTO } from "./campo-specifico-conservazioneDTO";

export class TempiConservazioneDTO {
  perSempre: boolean;
  //numeroAnniDaApertura: number;
  ereditaDaFascicolo: boolean;
  numeroAnniDaChiusura: number;
  campoSpecificoConservazione: CampoSpecificoConservazioneDTO;
  motivazione: string;
}
